export const CALENDAR_REQUEST = 'CALENDAR_REQUEST';
export const CALENDAR_FAIL = 'CALENDAR_FAIL';
export const CALENDAR_SUCCESS = 'CALENDAR_SUCCESS';
